<template>
  <div class="mirror-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="logo">
            <img src="/static/img/icons/sociolla-logo.svg" alt="SOCO" />
          </div>
          <h2>Halo, Selamat pagi!</h2>
          <h3>Semoga harimu menyenangkan!</h3>
        </div>
        <div class="col-sm-6">
          <div class="location-mirror">
            <div class="card card-inline">
              <div class="card-header">
                <figure>
                  <img src="/static/img/icons/location.svg" alt="SOCO" />
                </figure>
              </div>
              <div class="card-body">
                <h4>Lippo Mall Puri</h4>
                <p>Jalan Puri Indah Raya Blok U1, RT.3/RW.2, Kembangan</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="location-mirror-temp">
            <div class="card card-inlines">
              <div class="card-headers">
                <figure>
                  <img :src="weatherIcon" alt="weather-icon" />
                </figure>
              </div>
              <div class="card-bodys">
                <h4>{{ Math.round(weather.main.temp) }}° C</h4>
                <p>Jakarta Barat - Cerah Berawan</p>
              </div>
            </div>
          </div>
          <div class="clearfix">&nbsp;</div>
        </div>
        <div class="col-md-12">
          <div class="quote-content">
            <p v-if="quotes && quotes.length">
              <span>{{ quotes[0].quotes }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="clearfix">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const Config = require('~/config/default.env').default;

export default {
  name: 'smartMirror',
  data() {
    return {
      quotes: null,
      weather: { main: { temp: '27' } },
    };
  },
  computed: {
    weatherIcon() {
      if (this.weather.weather) {
        const icon = this.weather.weather[0].icon.replace('n', 'd'); // handle night icon
        if (icon === '01d') {
          return require('static/img/icons/weather-icons/sunny.svg');
        }
        if (icon === '02d' || icon === '03d' || icon === '04d') {
          return require('static/img/icons/weather-icons/cloudy.svg');
        }
        if (icon === '09d' || icon === '10d') {
          return require('static/img/icons/weather-icons/rain.svg');
        }
        if (icon === '11d') {
          return require('static/img/icons/weather-icons/heavy-rain.svg');
        }
      }
      return require('static/img/icons/weather-icons/cerah.svg');
    },
  },
  created() {
    // this.getQuotes();
    this.getWeather();
  },
  methods: {
    /*getQuotes(){
            axios
            .get(Config.MS_SOCO_PUBLIC_API_URL + 'beauty-quotes', {
                params: {
                    sort: '-created_at',
                    limit: 1
                }
            })
            .then(res => {
                this.quotes = res.data.data
            })
        },*/
    getWeather() {
      axios.defaults.withCredentials = false;
      axios
        .get('https://api.openweathermap.org/data/2.5/weather', {
          params: {
            q: 'Jakarta',
            units: 'metric',
            APPID: Config.OW_API_KEY,
          },
        })
        .then((res) => {
          this.weather = res.data;
        });
    },
  },
};
</script>

<style lang="scss">
@import 'smartMirror';
</style>
